<dx-data-grid
  (onSelectionChanged)="selectedDeviceId = $event.selectedRowKeys[0]"
  *ngIf="inputDisplayMode === 'table'"
  [columnAutoWidth]="true"
  [dataSource]="deviceList"
  [disabled]="(!selectedPartitionId && selectedPartitionId !== 0) || disabled"
  [height]="'100%'"
  [selectedRowKeys]="[selectedDeviceId]"
  [showBorders]="true"
  [wordWrapEnabled]="true"
  [showRowLines]="false"
  keyExpr="id">
  <dxo-toolbar>
    <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
    </dxi-item>
  </dxo-toolbar>
  <dxo-search-panel
    [visible]="true">
  </dxo-search-panel>
  <dxo-scrolling
    mode="standard">
  </dxo-scrolling>
  <dxo-selection
    [allowSelectAll]="false"
    [mode]="'single'"
    [selectByClick]="true">
  </dxo-selection>
  <dxo-paging
    [pageSize]="10"
    [enabled]="appService.isSmallScreen()">
  </dxo-paging>
  <dxi-column [dataField]="'name'" caption="{{'CHART_CREATION.DEVICE_NAME' | translate}}"></dxi-column>
  <dxi-column
    [dataField]="'online'"
    caption="{{'CHART_CREATION.DEVICE_ONLINE' | translate}}"
    [showEditorAlways]="false"
    [trueText]="translate.instant('COMMON.YES')"
    [falseText]="translate.instant('COMMON.NO')"></dxi-column>
</dx-data-grid>

<dx-drop-down-box
  #boxComponent
  *ngIf="inputDisplayMode === 'dropdown'"
  [dataSource]="deviceList"
  [disabled]="(!selectedPartitionId && selectedPartitionId !== 0)  || disabled"
  [dropDownOptions]="{
            wrapperAttr:{ class: 'deviceDropdown'}
          }"
  [value]="selectedDeviceId"
  displayExpr="name"
  placeholder="{{ 'CHART_CREATION.SELECT_DEVICE' | translate }}"
  valueExpr="id">

  <dx-data-grid
    (onSelectionChanged)="selectedDeviceId = $event.selectedRowKeys[0]; boxComponent.instance.close()"
    [columnAutoWidth]="true"
    [dataSource]="deviceList"
    [height]="'100%'"
    [selectedRowKeys]="[selectedDeviceId]"
    [showBorders]="false"
    [wordWrapEnabled]="true"
    [showRowLines]="false"
    keyExpr="id">
    <dxo-toolbar>
      <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
      </dxi-item>
    </dxo-toolbar>
    <dxo-search-panel
      [visible]="true">
    </dxo-search-panel>
    <dxo-paging
      [enabled]="false">
    </dxo-paging>
    <dxo-scrolling
      mode="standard">
    </dxo-scrolling>
    <dxo-selection
      [allowSelectAll]="false"
      [mode]="'single'"
      [selectByClick]="true">
    </dxo-selection>
    <dxi-column [allowSorting]="false" [dataField]="'name'"
                caption="{{'CHART_CREATION.DEVICE_NAME' | translate}}"></dxi-column>
    <dxi-column [allowSorting]="false" [dataField]="'online'"
                caption="{{'CHART_CREATION.DEVICE_ONLINE' | translate}}"
                [showEditorAlways]="false"
                [trueText]="translate.instant('COMMON.YES')"
                [falseText]="translate.instant('COMMON.NO')"></dxi-column>
  </dx-data-grid>

</dx-drop-down-box>
